// Smooth scroll helpers backed by the global Lenis instance.
export const scrollToId = (id, offset = -72) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (typeof window !== "undefined" && window.__lenis) {
    window.__lenis.scrollTo(el, { offset, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const scrollToPricing = () => scrollToId("pricing");
export const scrollToContact = () => scrollToId("contact");
